import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraSelect, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { TierComposition } from './TierComposition';
const columns = [
    {
        key: 'label',
        label: 'Labor category',
        parameterName: 'label',
        editable: false,
        perPeriod: false
    },
    {
        key: 'ftes',
        label: 'FTEs',
        parameterName: 'ftes',
        editable: true,
        perPeriod: false
    },
    {
        key: 'hours',
        label: 'Hours',
        parameterName: 'hours',
        editable: true,
        perPeriod: false
    },
    {
        key: 'rate',
        label: 'Rate',
        parameterName: 'rate',
        editable: false,
        perPeriod: false
    },
    {
        key: 'total',
        label: 'Total',
        parameterName: 'total',
        editable: false,
        perPeriod: false
    }
];
export function TierEditor({ config, configs, rateCard, referencingClins, onChange }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                title: config.tierLabel
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                children: [
                    "Used by CLINs: ",
                    referencingClins.join(', ') || 'None'
                ]
            }),
            /*#__PURE__*/ _jsx(TierComposition, {
                tier: config,
                rateCard: rateCard,
                columns: columns,
                periods: [],
                onChange: (tier)=>onChange({
                        ...config,
                        group: tier.group
                    })
            }),
            /*#__PURE__*/ _jsxs(SpecraSelect, {
                "aria-label": "Copy composition from tier",
                value: "",
                onChange: (event)=>{
                    const source = configs.find((c)=>c.id === event.target.value);
                    if (source) onChange({
                        ...config,
                        group: {
                            ...config.group,
                            lines: structuredClone(source.group.lines).map((line)=>({
                                    ...line,
                                    id: crypto.randomUUID()
                                }))
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ _jsx("option", {
                        value: "",
                        children: "Copy composition from…"
                    }),
                    configs.filter((c)=>c.id !== config.id).map((c)=>/*#__PURE__*/ _jsx("option", {
                            value: c.id,
                            children: c.tierLabel
                        }, c.id))
                ]
            })
        ]
    });
}
